"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateFile = void 0;
const MapmakerContext_1 = require("./MapmakerContext");
const MapmakerApi_1 = require("./MapmakerApi");
function updateFile(input) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const client = (0, MapmakerContext_1.getClient)();
        const result = yield client.mutate({
            mutation: MapmakerApi_1.UpdateFileHeavyDocument,
            variables: {
                input,
            },
        });
        // TODO - Handle errors?
        return Object.assign({}, (_a = result.data.updateMapmakerFile) === null || _a === void 0 ? void 0 : _a.file);
    });
}
exports.updateFile = updateFile;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2F2ZVV0aWxzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NsaWVudC9zYXZlVXRpbHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBQUEsdURBQThDO0FBQzlDLCtDQUl1QjtBQUV2QixTQUFzQixVQUFVLENBQzlCLEtBQThCOzs7UUFFOUIsTUFBTSxNQUFNLEdBQUcsSUFBQSwyQkFBUyxHQUFFLENBQUM7UUFFM0IsTUFBTSxNQUFNLEdBQUcsTUFBTSxNQUFNLENBQUMsTUFBTSxDQUFDO1lBQ2pDLFFBQVEsRUFBRSxxQ0FBdUI7WUFDakMsU0FBUyxFQUFFO2dCQUNULEtBQUs7YUFDTjtTQUNGLENBQUMsQ0FBQztRQUNILHdCQUF3QjtRQUN4Qix5QkFDSyxNQUFBLE1BQU0sQ0FBQyxJQUFJLENBQUMsa0JBQWtCLDBDQUFFLElBQUksRUFDdkM7O0NBQ0g7QUFmRCxnQ0FlQyJ9